module.exports = __webpack_public_path__ + "565fe74aad70cdeeb63e9b3acb269cab.svg";